<template>
    <v-row>
        <v-col xs="9">
            <v-text type="headline" v-margin.bottom="3">
                Какой тарифный план выбрать?
            </v-text>

            <div v-margin.bottom="3" v-for="tariff in tariffs">
                <div>
                    <v-text type="title" medium>{{ tariff.title }}</v-text>
                </div>
                <v-text v-html="tariff.description"></v-text>
            </div>
        </v-col>
    </v-row>
</template>
<script>
    export default {
        name: 'tariffs-info',
        props: {
            tariffs: {
                type: Array,
                default() {
                    return [];
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// TariffsInfo.vue?6927adab